import script from "./SecActions.vue?vue&type=script&setup=true&lang=js"
export * from "./SecActions.vue?vue&type=script&setup=true&lang=js"

import "./SecActions.vue?vue&type=style&index=0&id=ac05b5d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac05b5d2"]])

export default __exports__